import { useCallback } from "react";
import { useNavigate } from "react-router-dom";

/**
 * Volta para a tela de onde a pessoa veio (mantém filtros e página da lista) em vez de empilhar
 * uma tela nova no histórico. Se não houver tela anterior no app (link aberto direto), vai para
 * `alternativa`, substituindo a entrada atual.
 */
export function useVoltarOu(alternativa: string) {
  const navigate = useNavigate();
  return useCallback(() => {
    const posicao = (window.history.state as { idx?: number } | null)?.idx ?? 0;
    if (posicao > 0) navigate(-1);
    else navigate(alternativa, { replace: true });
  }, [navigate, alternativa]);
}
